import React, { useState } from 'react';
import axios from 'axios';

const GetStateOnClick = () => {
  const [locationstateName, setlocationstateName] = useState('');
  const [locationerror, setlocationerror] = useState('');
  const [locationloading, setlocationloading] = useState(false);

  const handleGetState = () => {
    setlocationloading(true);
    setlocationerror('');
    setlocationstateName('');

    if (!navigator.geolocation) {
      setlocationerror('Geolocation is not supported by your browser.');
      setlocationloading(false);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;

        try {
          const response = await axios.get(
            `https://api.opencagedata.com/geocode/v1/json?q=${latitude}+${longitude}&key=6c8da3bde2cc455d8bb5a5a2fca1f71b`
          );

          const components = response.data.results[0].components;
          const state =
            components.state || components.region || components.province || 'Unknown';

          setlocationstateName(state);
        } catch (err) {
          setlocationerror('Failed to fetch state name.');
        } finally {
          setlocationloading(false);
        }
      },
      (err) => {
        setlocationerror('locationerror getting location: ' + err.message);
        setlocationloading(false);
      }
    );
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial' }}>
      <button onClick={handleGetState} style={{ padding: '10px 20px', cursor: 'pointer' }}>
        Get My State
      </button>

      <div style={{ marginTop: '20px' }}>
        {locationloading && <p>Fetching location...</p>}
        {locationerror && <p style={{ color: 'red' }}>{locationerror}</p>}
        {locationstateName && <p>📍 You are in: <strong>{locationstateName}</strong></p>}
      </div>
    </div>
  );
};

export default GetStateOnClick;
